import router from "next/router";
import { useDispatch } from "react-redux";
import { OX_DEPOT_FILTER } from "../config/constants";
import { routes } from "../config/route-config";
import { saveToLocal } from "../helpers/handleLocalStorage";
import { getDepots } from "../lib/redux/slices/depotsSlice";
import { depotTypes } from "../lib/types/depots";

interface IProps {
  onSuccess: (depotId?: number) => void;
}
export const useDepotChange = ({ onSuccess }: IProps) => {
  const doesInclude = (route: string) => router.pathname.includes(route);
  const dispatch = useDispatch();

  const onChange = (depot: depotTypes | undefined) => {
    doesInclude(routes.DepotProfile.url) &&
      router.push(`${routes.DepotProfile.url}/${depot?.id}`);

    dispatch(getDepots({ depotId: depot?.id, depotName: depot?.name }));
    onSuccess?.(depot?.id);

    saveToLocal({
      name: OX_DEPOT_FILTER,
      value: {
        depotId: depot?.id,
        depotName: depot?.name
      }
    });
  };

  return { onChange };
};
